export const gettext = window.gettext || (msgid => msgid);

const _ = gettext;

export const pgettext = window.pgettext || ((context, msgid) => msgid);

export const interpolate = (fmt, obj, named = true) => (window.interpolate || gettext)(fmt, obj, named);

export const getFormat = window.get_format || (fmt => fmt);

export const ngettext = window.ngettext || ((singular, plural, count) => count === 1 ? singular : plural);

export const npgettext = window.npgettext || ((context, singular, plural, count) => count === 1 ? singular : plural);

export default _;
